<external-assets></external-assets>
<div *ngIf="showLoader" class="app__loading">
  <app-header></app-header>
  <ng-container *ngIf="showStepper">
    <app-stepper></app-stepper>
  </ng-container>
  <div class="app__loading__content">
    <pichincha-spinner percentage="50%" [size]="100"></pichincha-spinner>
  </div>
  <app-footer></app-footer>
</div>
<router-outlet></router-outlet>
<div *ngIf="showIdleModal">
  <app-modal
    labelPrimaryButton="Continuar"
    labelSecondaryButton="Cerrar sesión"
    (closeButtonClick)="closeIdleModal()"
    (backgroundClick)="closeIdleModal()"
    (primaryButtonClick)="closeIdleModal()"
    (secondaryButtonClick)="redirectToHome()"
    [maxWidth]="700"
  >
    <pichincha-spot-module
      variant="warning"
      spot-title="¿Necesitas más tiempo?"
      spot-description="Tu sesión terminará pronto."
    ></pichincha-spot-module>
  </app-modal>
</div>
